// @flow

import React from 'react';
import uuid from 'uuid';
import { Card, Button, Dimmer, Icon, Divider, Form } from 'semantic-ui-react';
import ResourceSelector from 'shared/components/ResourceSelector/index';
import ResourceImage from 'shared/components/ResourceImage';
import ResourceDimmer from 'shared/components/ResourceDimmer';
import * as ResourceService from 'catalog/services/resources';
import type { PluginProps } from '../QuestionContent';

const createImageChoice = image => ({
  id: uuid(),
  value: image,
});

const isContentValid = content => {
  return true;
};

const styles = {
  card: {
    maxWidth: '220px',
  },
  input: {
    margin: '8px',
  },
  group: {
    marginBottom: '1em',
  },
};

const ImagesContent = ({ content, onChange }: PluginProps) => {
  const choices = content.choices || [];

  const change = content =>
    onChange({
      ...content,
      isValid: isContentValid(content),
      hasChanged: true,
    });

  const addChoice = image =>
    change({
      ...content,
      choices: [...choices, createImageChoice(image)],
    });

  const deleteChoice = (choice: Choice) =>
    change({
      ...content,
      choices: choices.filter(c => c.id !== choice.id),
    });

  const changeMultiSelect = (_, { value, checked }) =>
    onChange({
      ...content,
      multiSelect: value === 'multiple' && checked,
    });

  return (
    <div>
      <Divider />
      <Form.Group inline>
        <label>Nombre de réponse(s) souhaité</label>
        <Form.Radio
          label="Réponse unique"
          value="single"
          checked={!content.multiSelect}
          onChange={changeMultiSelect}
        />
        <Form.Radio
          label="Réponse à choix multiple"
          value="multiple"
          checked={content.multiSelect}
          onChange={changeMultiSelect}
        />
      </Form.Group>
      <Divider hidden />
      <ImageSelector onSelected={addChoice} />
      <Card.Group itemsPerRow={4} style={styles.group}>
        {choices.map(c => (
          <ImageChoice key={c.id} choice={c} onDelete={deleteChoice} />
        ))}
      </Card.Group>
      <Divider />
    </div>
  );
};

type SelectorProps = {
  onSelected: (resource: BucketResource) => void,
};

type SelectorState = {
  selectorOpen: boolean,
};

class ImageSelector extends React.Component<SelectorProps, SelectorState> {
  props: SelectorProps;
  state: SelectorState;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectorOpen: false,
    };
  }

  onShowSelector = () => this.setState({ selectorOpen: true });
  onHideSelector = () => this.setState({ selectorOpen: false });

  onResourceSelected = (resource: BucketResource) => {
    this.setState({
      selectorOpen: false,
    });

    this.props.onSelected(ResourceService.createTemplateResource(resource));
  };

  render() {
    const { selectorOpen } = this.state;

    const content = (
      <div>
        <Button
          type="button"
          primary
          icon
          labelPosition="right"
          onClick={this.onShowSelector}
        >
          <Icon name="image" />
          Sélectionner
        </Button>
      </div>
    );

    return (
      <Card centered style={styles.card}>
        <Dimmer.Dimmable
          as={ResourceImage}
          dimmed
          dimmer={{ active: true, content }}
          dimmerProps={{ inverted: true }}
        />
        <ResourceSelector
          open={selectorOpen}
          resourceType="image"
          onResourceSelected={this.onResourceSelected}
          onClose={this.onHideSelector}
        />
      </Card>
    );
  }
}

const ImageChoice = ({ choice, onDelete }: Props) => {
  const deleteChoice = () => onDelete(choice);

  return (
    <Card>
      <ResourceDimmer resource={choice.value && choice.value.source}>
        <div>
          <Button
            type="button"
            onClick={deleteChoice}
            icon="close"
            color="red"
            content="Supprimer"
            labelPosition="right"
          />
        </div>
      </ResourceDimmer>
    </Card>
  );
};

export default ImagesContent;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/contents/ImagesContent.js